import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { validation } from '../validation/Regex';
import { login } from '../services/ApiServices';
import ToastMsg from '../component/comman/ToastMsg';

const Login = ({ toggleAuthMode }) => {
  const [userInput, setUserInput] = useState({
    email: '',
    password: '',
    emailError: '',
    passwordError: '',
    isValidEmail: false,
    isLoader: false,
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setUserInput({
      ...userInput,
      [e.target.name]: e.target.value,
    });
  };

  const checkValidation = () => {
    const { email, password } = userInput;
    if (email === '' || password === '' || password.length < 3 || !validation(email)) {
      return true;
    }
    return false;
  };

  const handleSubmit = () => {
    let params = {
      email: userInput.email,
      password: userInput.password,
    };

    setUserInput({
      ...userInput,
      isLoader: true,
    });

    login(params).then((res) => {
        if (res.status === 200) {
            console.log(res,"login");
            localStorage.setItem('accessToken', res.data.tokens.access);
            localStorage.setItem('role', res.data.user_role);
            window.location.href="/report"
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          window.location.href = "/";
        }
        let error = err?.response?.data?.error || "something went wrong";
        ToastMsg(error, "error");
      });
  };

  const { email, password } = userInput;

  return (
    <div className='login-wrapper d-flex justify-content-center align-items-center'>
      <div className='login-inner'>
        {/* <h2 className='mb-2'>Balanceko</h2> */}
        <h2 className='mb-2'>Welcome Back</h2>
        <p className='pb-50'>Don’t have an account? <span onClick={toggleAuthMode}>Sign Up</span></p>
        <form>
          <div className="form-group mb-4">
            <input type="email" className="form-control" aria-describedby="emailHelp" placeholder="Email" value={email} name='email' onChange={handleChange} autoComplete="off"/>
          </div>
          <div className="form-group mb-4">
            <input type="password" value={password} name="password" className="form-control" placeholder="Password" onChange={handleChange} autoComplete="off"/>
          </div>
          <button type="button" onClick={ handleSubmit} disabled={checkValidation()} className="btn w-100">Login</button>
        </form>
      </div>
    </div>
  );
}

export default Login;